import { render, staticRenderFns } from "./MapleBear2.vue?vue&type=template&id=78a5ac09&scoped=true"
import script from "./MapleBear2.vue?vue&type=script&lang=js"
export * from "./MapleBear2.vue?vue&type=script&lang=js"
import style0 from "./MapleBear2.vue?vue&type=style&index=0&id=78a5ac09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5ac09",
  null
  
)

export default component.exports